import {
    NETWORK_ERROR,
    CLEAR_NETWORK_ERROR,
    USER_NOT_FOUND_ERROR,
    VWGOA_SERVER_ERROR_GET_REQUEST_STATUS,
    VWGOA_USER_NOT_FOUND_ERROR,
} from "./constants";

const INITIAL_STATE = {};
export default function errorsReducer(state = INITIAL_STATE, action) {
    const { payload, type } = action;

    switch (type) {

    case NETWORK_ERROR:
        return {
            ...payload,
        };
    case USER_NOT_FOUND_ERROR:
        return {
            ...payload,
        };
    case CLEAR_NETWORK_ERROR:
        return {
            ...payload,
        };
    case VWGOA_SERVER_ERROR_GET_REQUEST_STATUS:
        return {
            ...payload,
        };
    case VWGOA_USER_NOT_FOUND_ERROR:
        return {
            ...payload,
        };
    default:
        return state;
    }

};
